import type { GemxQlQueryResponse } from '~/core/gemxql/graphql';
import type { IVariantType } from '~/modules/campaign/types';
import type { IAnalyticMetric } from '~/types/metric';

import { buildAnalyticMetric } from './buildAnalyticMetric';
import { extractQueryRows } from '~/core/gemxql/helpers';
import { ERowReaderMode } from '~/core/gemxql/types';

export interface IExtractCampaignDetailDataParams {
  response?: GemxQlQueryResponse;
  variantKey: IVariantType;
  interval: string;
}

export interface IExtractedCampaignDetailData {
  totalsMetric?: IAnalyticMetric;
  intervalMetrics: IAnalyticMetric[];
}

export const extractCampaignDetailData = ({
  response,
  variantKey,
  interval,
}: IExtractCampaignDetailDataParams): IExtractedCampaignDetailData => {
  const rows = extractQueryRows(response);
  if (!rows.length) return { intervalMetrics: [] };

  const intervalMetrics: IAnalyticMetric[] = rows.map((row) => {
    const dateRaw = row[interval];
    const date = dateRaw === null || dateRaw === undefined ? '' : String(dateRaw);
    return buildAnalyticMetric({ row, readerMode: ERowReaderMode.DEFAULT, date, variantKey });
  });

  const totalsMetric = buildAnalyticMetric({
    row: rows[0],
    readerMode: ERowReaderMode.TOTALS,
    date: '',
    variantKey,
  });

  return { totalsMetric, intervalMetrics };
};
